export { version } from './src/package.js'
import { search } from './src/search.js'

if (typeof jQuery != 'undefined') {
  jQuery.extend(jQuery.fn, {
    search: search
  })
}
